module.exports = __webpack_public_path__ + "e4d04a8f7203f097fc6c527ce86bcbc8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/MainMenu/MenuSandwiches.png
// module id = 407
// module chunks = 0